export const boardViewSwitcherTour = {
  key: "boardViewSwitcher",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-viewswitcher-tabs"]',
      content: t("Tour_BoardViewSwitcher_Tabs"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-viewswitcher-kanban"]',
      content: t("Tour_BoardViewSwitcher_Kanban"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-viewswitcher-gantt"]',
      content: t("Tour_BoardViewSwitcher_Gantt"),
      placement: "bottom",
    },
  ],
};
